import { updateBeginWorkStep } from 'src/providers/UpdateBeginWorkStepsProvider';
import { BEGIN_WORK_STEPS_IDS } from 'src/constants/beginWorksSteps';

import useGoTo from 'src/hooks/useGoTo';

import KeywordsContent from '../Keywords/Content';

export default function Keywords() {
    const goTo = useGoTo();

    const onSuccessHandler = () => {
        updateBeginWorkStep({
            currentStep: BEGIN_WORK_STEPS_IDS.ADD_KEYWORDS,
            onSuccess: () => {
                goTo('/begin_work/collections');
            },
        });
    };

    return (
        <KeywordsContent
            onSuccess={onSuccessHandler}
            isOnboarding
        />
    );
}
